import React from 'react';

const ACGMEIcon = ({ size = 24, className = '' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="60 50 180 180"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Just the stylized "A" - no background */}
      <g stroke="currentColor" strokeWidth="2.5" strokeLinejoin="round">
        <path
          fill="currentColor"
          d="M127.77,150.02l-0.49,1.7l-0.66,2.28l-9.4,32.73c0,0-9.91,28.11-33.87,18.66c0,0,19.13,5.56,35.32-48.46
          c0.27-0.9,0.54-1.82,0.81-2.76c0.02-0.06,0.03-0.11,0.05-0.17l0.72-1.94C122.74,151.28,125.26,150.59,127.77,150.02z"
        />
        <polygon fill="currentColor" points="149.97,72.67 128.22,148.46 120.85,150.49" />
        <polygon fill="currentColor" points="178.79,149.91 172.29,148.71 150.99,72.67" />
        <path
          fill="currentColor"
          d="M216.92,204.93c0,0-26.42,15.36-37.79-31.79l-2.74-9.79l-3.1-11.05l-0.57-2.04c2.19,0.47,4.47,1.06,6.82,1.77
          l0.88,2.46l3.2,8.87l3.19,8.87C186.82,172.21,199.26,206.93,216.92,204.93z"
        />
        <path
          fill="currentColor"
          d="M220.15,202.63h-2.03c0,0,4.19-9.22-11.25-28.46c-6.15-7.67-12.71-13.05-19.86-16.78
          c-2.14-1.12-4.33-2.09-6.58-2.91c-2.32-0.86-4.69-1.59-7.13-2.19c-1.5-0.37-3.02-0.69-4.57-0.97c-5.85-1.07-12.08-1.55-18.76-1.68
          c-7.13-0.14-13.69,0.26-19.84,1.47c-0.96,0.19-1.91,0.39-2.85,0.62c-2.67,0.64-5.26,1.45-7.79,2.45c-1.53,0.6-3.03,1.27-4.53,2.01
          c-8.01,3.99-15.5,10.11-22.96,19.13c0,0-13.48,16.71-10.25,27.31h-1.73c0,0-8.53-9.48,3.34-26.51c6.27-9,18.11-16.94,31.27-22.06
          c1.85-0.72,3.74-1.38,5.63-1.99c2.49-0.79,5-1.48,7.51-2.04c0.71-0.17,1.42-0.32,2.13-0.46c6.96-1.41,13.85-1.88,20.07-1.2
          c0,0,7.76-0.77,18.76,1.11c1.29,0.22,2.62,0.48,3.99,0.77c2.19,0.47,4.47,1.06,6.82,1.77c2.28,0.69,4.62,1.5,6.99,2.45
          c8.33,3.34,17.06,8.43,25.05,16.13C211.59,170.6,229.75,186.61,220.15,202.63z"
        />
      </g>
    </svg>
  );
};

export default ACGMEIcon;
